import NamedDto from 'modules/base/dto/NamedDto';

export default class PiConnectionTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.apiUrl = null;
		/** @type {string} */
		this.username = null;
		/** @type {string} */
		this.serverId = null;
	}

	/**
	 * @typedef {Object} _PiConnectionTableDtoProps
	 * @property {string} apiUrl
	 * @property {string} username
	 * @property {string} serverId
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PiConnectionTableDtoProps} PiConnectionTableDtoProps
	 */
	/**
	 * @param {PiConnectionTableDtoProps} props
	 * @returns {PiConnectionTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.apiUrl = props?.apiUrl;
		this.username = props?.username;
		this.serverId = props?.serverId;
		return this;
	}
}
